/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_UploadedInputs */

const cs_social_templates_uploaded = /** @type {(inputs: Social_Templates_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona nahrána.`)
};

const en_social_templates_uploaded = /** @type {(inputs: Social_Templates_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template uploaded.`)
};

/**
* | output |
* | --- |
* | "Template uploaded." |
*
* @param {Social_Templates_UploadedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_uploaded = /** @type {((inputs?: Social_Templates_UploadedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_UploadedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_uploaded(inputs)
	return cs_social_templates_uploaded(inputs)
});